import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoImage = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52,
	height: 42,
	fill: "none",
	viewBox: "0 0 52 42",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E1E1E1",
			d: "M37.3499 41.4465H0L16.4038 11.8046C17.2592 10.2588 19.4758 10.2425 20.3539 11.7754L37.3499 41.4465Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EEEEEE",
			d: "M52.0003 41.4445H37.3501L31.2324 30.6581L36.4575 21.1621C37.3112 19.6105 39.5347 19.5934 40.4122 21.1316L52.0003 41.4445Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 45.3989,
			cy: 4.41725,
			r: 3.86379,
			fill: "#E1E1E1"
		})
	]
});
const ForwardRef = forwardRef(SvgNoImage);
export default ForwardRef;
